import { render, staticRenderFns } from "./recommendationeditor.vue?vue&type=template&id=6dab5b26&scoped=true&"
import script from "./recommendationeditor.vue?vue&type=script&lang=js&"
export * from "./recommendationeditor.vue?vue&type=script&lang=js&"
import style0 from "./recommendationeditor.vue?vue&type=style&index=0&id=6dab5b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dab5b26",
  null
  
)

export default component.exports